// extracted by mini-css-extract-plugin
module.exports = {"warningLabel":"WarningLabel--warning-label--32Gsx"};